import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { usePostUpdateItemPriceMutation,useTotalItemListMutation,useItemUOMMutation,useCustomerDetailsMutation,useTotalBatchNoListMutation,useItemSupplierMutation,useGetItemDetailsMutation } from "../../../../store/api/itemapi";
import { useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import Attachment from "../../../../utils/Attachment";
const EditForm = () => {
  const navigate = useNavigate();
   const location = useLocation();
        const IdData = location.state?.ItemId;
        const [podata, setpodata] = useState('')
    // console.log('ids:',IdData)
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [UpdateItemPrice] = usePostUpdateItemPriceMutation();
  const [ItemListApi] = useTotalItemListMutation();
  const [ItemUOMListApi] = useItemUOMMutation();
  const [ItemCustomerListApi] = useCustomerDetailsMutation();
  const [ItemBatchListApi] = useTotalBatchNoListMutation();
  const [ItemSupplierListApi] = useItemSupplierMutation();
  const [GetItemDetailsApi] = useGetItemDetailsMutation();

  // tab1
    const [Item_Code_list, setItem_Code_list] = useState([]);
  const [select_Item_Code, setselect_Item_Code] = useState("");
  const [ItemName, setItemName] = useState("");
  const [ItemDescription, setItemDescription] = useState("");
    const [Item_UOM_list, setItem_UOM_list] = useState([]);
  const [select_Item_UOM, setselect_Item_UOM] = useState("");
  const [PackingUnit, setPackingUnit] = useState("");
  const [PriceList, setPriceList] = useState("");
    const [Customer_list, setCustomer_list] = useState([]);
  const [select_Customer, setselect_Customer] = useState("");
    const [Supplier_list, setSupplier_list] = useState([]);
  const [select_Supplier, setselect_Supplier] = useState("");
    const [BatchNo_list, setBatchNo_list] = useState([]);
  const [select_BatchNo, setselect_BatchNo] = useState("");
  const [Currency, setCurrency] = useState("INR");
  const [Rate, setRate] = useState("");
  const [ValidFrom, setValidFrom] = useState("");
  const [ValidUpto, setValidUpto] = useState("");
  const [LeadTimeindays, setLeadTimeindays] = useState("");
  const [Note, setNote] = useState("");
  const [Reference, setReference] = useState("");
  // const [Buying, setBuying] = useState(0);
  // const [Selling, setSelling] = useState(0);

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   Item_Code: false,
      Item_UOM: false,
      PriceList: false,
      Rate: false,
  });

  // console.log("item c:", select_Item_Code);
  useEffect(() => {
     const getItemItem_Code = async () => {
        const ItemItem_CodeApiData = await ItemListApi()
        setItem_Code_list(ItemItem_CodeApiData.data.data);
      }
     const getItemItem_UOM = async () => {
        const ItemItem_UOMApiData = await ItemUOMListApi()
        setItem_UOM_list(ItemItem_UOMApiData.data.data);
      }
   const getItemCustomer = async () => {
        const ItemCustomerApiData = await ItemCustomerListApi()
        setCustomer_list(ItemCustomerApiData.data.data);
      }

        const getItemBatchNo = async () => {
        const ItemBatchNoApiData = await ItemBatchListApi()
        setBatchNo_list(ItemBatchNoApiData.data.data);
      }

       const getItemSupplier = async () => {
        const ItemSupplierApiData = await ItemSupplierListApi()
        setSupplier_list(ItemSupplierApiData.data.data);
      }

      const getItemDetails = async () => {
  if (!select_Item_Code) {
    console.warn("Item code not selected");
    return;
  }

  try {
    const response = await GetItemDetailsApi(select_Item_Code);
    const fullD = response.data.data;
    // console.log("item d:", response.data.data);
    setItemName(fullD.item_name);
    setItemDescription(fullD.description);
    setselect_Item_UOM(fullD.stock_uom);

  } catch (err) {
    console.error("Error fetching item:", err);
  }
};

    getItemItem_Code();
    getItemItem_UOM();
    getItemCustomer()
    getItemBatchNo();
    getItemSupplier();
    if (select_Item_Code) {
    getItemDetails();
  }
  }, [select_Item_Code]);

const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();
const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
    useEffect(() => {
        if (IdData) {
            itemDetails({ doctype: 'Item Price', name: IdData })
                .unwrap()
                .then((response) => {
                    const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                    setpodata(response)
                    console.log(item, "Api response");
                    setselect_Item_Code(item.item_code);
                    setItemName(item.item_name);
                    setItemDescription(item.item_description);
                    setselect_Item_UOM(item.uom)
                    setPackingUnit(item.packing_unit)
                    setPriceList(item.price_list)
                    setselect_Customer(item.customer)
                    setselect_Supplier(item.supplier)
                    setselect_BatchNo(item.batch_no)
                    setCurrency(item.currency)
                    setRate(item.price_list_rate)
                    setValidFrom(item.valid_from)
                    setValidUpto(item.valid_upto)
                    setLeadTimeindays(item.lead_time_days)
                    setNote(item.note)
                    setReference(item.reference)
                    setAttachmentsList(docinfo.attachments); // ✅ Correct place
                   
                })
                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No Id Data found in location state');
        }
    }, [IdData, itemDetails]);
  const handleSubmit = async () => {

  let buying = "0";
  let selling = "0";
if (PriceList === "Standard Buying") {
    buying = "1";
    setselect_Supplier(select_Supplier)
    setPriceList("Standard Buying")
  }
  if (PriceList === "Standard Selling") {
    selling = "1";
    setPriceList("Standard Selling")
    setselect_Customer(select_Customer);
  }

    setFieldErrors({
      Item_Code: false,
      Item_UOM: false,
      PriceList: false,
      Rate: false,
    });

    let hasError = false;
    const newErrors = {
      Item_Code: !select_Item_Code,
      Item_UOM: !select_Item_UOM,
      PriceList: !PriceList,
      Rate: !Rate,
    };

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some((error) => error);

    if (!select_Item_Code) {
      setptype("Error");
      setError("Please Select Item Code.");
      setShowError(true);
      return;
    }
    if (!select_Item_UOM) {
      setptype("Error");
      setError("Please Select UOM.");
      setShowError(true);
      return;
    }

    if (!PriceList) {
      setptype("Error");
      setError("Please Select Price List.");
      setShowError(true);
      return;
    }

    if (!Rate) {
      setptype("Error");
      setError("Please Fill Rate.");
      setShowError(true);
      return;
    }

  

  const payload = {
    name: IdData,
    item_code: select_Item_Code,
    item_name: ItemName,
    item_description: ItemDescription,
    uom: select_Item_UOM,
    packing_unit: PackingUnit,
    price_list:PriceList,
    buying,
    selling,
    supplier:select_Supplier,
    customer:select_Customer,
    batch_no: select_BatchNo,
    currency: Currency,
    price_list_rate: Rate,
    valid_from: ValidFrom,
    valid_upto: ValidUpto,
    lead_time_days: LeadTimeindays,
    note: Note,
    reference: Reference,
    brand: "",
  };

  console.log("update Item price payload:", payload);
    try {
      const response = await UpdateItemPrice(payload); //RTK mutation or fetch

       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Updation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Item Price updated successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/item-price/item-price-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };
  return (
    <FormLayout
      title="Edit Item Price"
      breadcrumbs={[
        { label: "Item Price"},
        { label: "Item Price List", url: "/master/item-price/item-price-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/item-price/create-item-price"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

         <Attachment doctype="Item Price"  docname={IdData}  />    

          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                     IdData={IdData} Item_Code={{ Item_Code_list: Item_Code_list, setselect_Item_Code: setselect_Item_Code, select_Item_Code: select_Item_Code, Error: fieldErrors.Item_Code }}
                    
  Item_UOM={{ Item_UOM_list: Item_UOM_list, setselect_Item_UOM: setselect_Item_UOM, select_Item_UOM: select_Item_UOM, Error: fieldErrors.Item_UOM }}
                    PackingUnit={{
                      PackingUnit: PackingUnit,
                      setPackingUnit: setPackingUnit,
                      PackingUnit: PackingUnit,
                      Error: fieldErrors.PackingUnit,
                    }}
                    PriceList={{
                      PriceList: PriceList,
                      setPriceList: setPriceList,
                      PriceList: PriceList,
                      Error: fieldErrors.PriceList,
                    }}
                      Customer={{ Customer_list: Customer_list, setselect_Customer: setselect_Customer, select_Customer: select_Customer, Error: fieldErrors.Customer }}
                      BatchNo={{ BatchNo_list: BatchNo_list, setselect_BatchNo: setselect_BatchNo, select_BatchNo: select_BatchNo, Error: fieldErrors.BatchNo }}
                      Supplier={{ Supplier_list: Supplier_list, setselect_Supplier: setselect_Supplier, select_Supplier: select_Supplier, Error: fieldErrors.Supplier }}
                    Currency={{
                      Currency: Currency,
                      setCurrency: setCurrency,
                      Currency: Currency,
                      Error: fieldErrors.Currency,
                    }}
                    Rate={{
                      Rate: Rate,
                      setRate: setRate,
                      Rate: Rate,
                      Error: fieldErrors.Rate,
                    }}
                    ValidFrom={{
                      ValidFrom: ValidFrom,
                      setValidFrom: setValidFrom,
                      ValidFrom: ValidFrom,
                      Error: fieldErrors.ValidFrom,
                    }}
                    ValidUpto={{
                      ValidUpto: ValidUpto,
                      setValidUpto: setValidUpto,
                      ValidUpto: ValidUpto,
                      Error: fieldErrors.ValidUpto,
                    }}
                    LeadTimeindays={{
                      LeadTimeindays: LeadTimeindays,
                      setLeadTimeindays: setLeadTimeindays,
                      LeadTimeindays: LeadTimeindays,
                      Error: fieldErrors.LeadTimeindays,
                    }}
                    Note={{
                      Note: Note,
                      setNote: setNote,
                      Note: Note,
                      Error: fieldErrors.Note,
                    }}
                    Reference={{
                      Reference: Reference,
                      setReference: setReference,
                      Reference: Reference,
                      Error: fieldErrors.Reference,
                    }}
                    // Buying={{
                    //   Buying: Buying,
                    //   setBuying: setBuying,
                    //   Buying: Buying,
                    //   Error: fieldErrors.Buying,
                    // }}
                    // Selling={{
                    //   Selling: Selling,
                    //   setSelling: setSelling,
                    //   Selling: Selling,
                    //   Error: fieldErrors.Selling,
                    // }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default EditForm;
